// extracted by mini-css-extract-plugin
module.exports = {"serviceContainer":"styles_serviceContainer__Ti8X8","serviceItem":"styles_serviceItem__ETm_R"};